import classNames from "classnames";
import noop from "lodash/noop";
import React, { FunctionComponent, ReactElement, ReactNode } from "react";
import Checkbox from "@Components/atoms/Checkbox";
import "./style.scss";

interface Props {
  checked: boolean;
  children: ReactNode;
  disabled?: boolean;
  onChange: () => void;
}

const CartCheckboxWithLabel: FunctionComponent<Props> = ({
  children,
  onChange,
  disabled,
  checked,
}): ReactElement => {
  return (
    <div
      className={classNames("CartCheckboxWithLabel", {
        "CartCheckboxWithLabel--disabled": disabled,
      })}
      onClick={() => onChange()}
    >
      <Checkbox checked={checked} disabled={disabled} onChange={noop} type="square" />
      <span className="CartCheckboxWithLabel-text">{children}</span>
    </div>
  );
};

export default CartCheckboxWithLabel;
